export enum BackupLicenseStatus {
  Assigned = 'Assigned',
  Inactive = 'Inactive',
  NotAssigned = 'Not Assigned',
  NotAvailable = 'Not Available'
}
